<template>
  <div id="ranking-board">
    <div class="ranking-board-title">各分公司总人数</div>
    <dv-scroll-ranking-board :config="val" style="width: 100%; height: 600px" :key="key" />
  </div>
</template>

<script>
export default {
  props: {
    value: Object,
    config: Object
  },

  data() {
    return {
      val: {
        data: [],
        rowNum: 9
      },
      key: new Date().getTime()
    }
  },
  methods: {
    LoadData() {
      this.$matrix
        .AjaxGet3(
          'Users',
          'GetList',
          {
            GetCompany: true,
            Groups: ['Company'],
            Fields: ['IdCount']
          },
          this.config.Role,
          this.config.RoleField
        )
        .then((data) => {
          if (data.Items && data.Items.length) {
            let list = data.Items.filter((item) => {
              return item.Company && item.Company.Name
            }).map((t) => {
              return {
                name: t.Company.Name,
                value: t.IdCount
              }
            })
            this.val.data = list
            this.val.rowNum = list.length
            this.key = new Date().getTime()
          }
        })
        .catch((e) => {
          this.$matrix.ShowError(e)
        })
    }
  },
  created() {
    this.LoadData()
  }
}
</script>

<style scoped>
.active {
  color: #4d99fc;
}

#ranking-board {
  width: 90%;
  -webkit-box-shadow: 0 0 3px #00f;
  box-shadow: 0 0 3px #00f;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  background-color: rgba(6, 30, 93, 0.5);
  border-top: 2px solid rgba(1, 153, 209, 0.5);
  padding: 0 30px;
}

#ranking-board .ranking-board-title {
  font-weight: 700;
  height: 50px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 20px;
}

#ranking-board .dv-scroll-ranking-board {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

/deep/.ranking-info .rank {
  display: none;
}
</style>
 